import { AvailableApps } from '~/config/apps'

import throwAppError from '~/utils/throwAppError'

import useRouteData from '~/hooks/useRouteData'

import MarketGuideStartPage from '~/components/MarketGuide/pages/MarketGuideStartPage'
import JobsStartPage from '~/components/Jobs/pages/JobsStartPage'
import FamilyStartPage from '~/components/Family/pages/FamilyStartPage'
import ChurchEventStartPage from '~/components/ChurchEvent/pages/ChurchEventStartPage'

import type * as Types from './types'
import type { RootLoaderData } from '~/types'

const StartPage: Types.StartPageComponent = () => {
    const { app } = useRouteData<RootLoaderData>('root')

    if (!app || !app.id) {
        throwAppError()
    }
    
    switch(app.id) {
        case AvailableApps.MarketGuide:
            return (
                <MarketGuideStartPage />
            )

        case AvailableApps.Jobs:
            return (
                <JobsStartPage />
            )

        case AvailableApps.Family:
            return (
                <FamilyStartPage />
            )

        case AvailableApps.ChurchEvent:
            return (
                <ChurchEventStartPage />
            )

        default:
            throwAppError()
            
            return (
                null
            )
    }
}

export default StartPage